import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CommaFormatPipe } from 'src/app/common/Pipe/comma-format.pipe';

@NgModule({
  declarations: [CommaFormatPipe],
  imports: [CommonModule],
  exports: [CommaFormatPipe], // ✅ VERY IMPORTANT
  providers: [DecimalPipe]
})
export class SharedModule { }
